export const complainantContactReducer = values => {
  // @key expected by hasSingleContacted
  // @val corresponding key on the values prop object
  const fieldMap = {
    email: 'personal_email',
    work_email: 'work_email',
    home_phone: 'complainant_home_phone',
    cell_phone: 'complainant_cell_phone',
    work_phone: 'complainant_work_phone',
    address: 'address',
    city: 'city',
    state: 'state',
    zip: 'zip'
  }

  // Creates an object from the keys in fieldMap and its corresponding key:value
  // from the values prop object
  const fieldMapReducer = (acc, f) => ({ ...acc, [f]: values[fieldMap[f]] })
  return Object.keys(fieldMap).reduce(fieldMapReducer, {})
}
